import { configureStore } from "@reduxjs/toolkit"

import updateSignupModalsReducer from "../container/benfeitor/modals/redux/update-user-data-modal-slice"

export const store = configureStore({
  reducer: {
    updateSignupModal: updateSignupModalsReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
